/* Read each hero photograph’s intrinsic aspect ratio from its Liquid image dimensions. */

(function () {
  function ratioOf(img) {
    if (!img) return null;
    var w = parseFloat(img.getAttribute('width')) || img.naturalWidth;
    var h = parseFloat(img.getAttribute('height')) || img.naturalHeight;
    if (!w || !h) return null;
    return (w / h).toFixed(4);
  }

  function setRatio() {
    var heroes = document.querySelectorAll('.aob-hero');

    for (var i = 0; i < heroes.length; i++) {
      var hero = heroes[i];
      var all = hero.querySelector('.aob-hero__img--all');

      var d = ratioOf(hero.querySelector('.aob-hero__img--d') || all);
      if (d) hero.style.setProperty('--aob-hero-ar', d);

      var m = ratioOf(hero.querySelector('.aob-hero__img--m') || all);
      if (m) hero.style.setProperty('--aob-hero-ar-m', m);
    }
  }

  setRatio();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setRatio);
  }
  // the theme editor rebuilds a section in place when its settings change
  document.addEventListener('shopify:section:load', setRatio);
})();
